"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersDataModelT = exports.ManagementRoleT = exports.ManagementRoleKinds = exports.PermissionHRT = exports.PermissionPayrollT = exports.PermissionBillingT = exports.PermissionRostersT = exports.PermissionRosterT = exports.UserGroupT = exports.SyncModelT = exports.HRModelT = exports.PayrollModelT = exports.BillingModelT = exports.SubRosterT = exports.ResidentT = exports.HREmployeeT = exports.EmployeeT = exports.UserT = exports.ResidentLinkT = exports.SubFacilityT = void 0;
const tBox = __importStar(require("@sinclair/typebox"));
const meta_types_1 = require("./meta-types");
exports.SubFacilityT = tBox.Object({
    Facility: tBox.Number(),
    SubFacility: tBox.Number(),
    Name: tBox.String(),
});
exports.ResidentLinkT = tBox.Object({
    ID: tBox.String(),
    BillingSubFacility: tBox.Number(),
    ResidentCode: tBox.Number(),
    ResidentContact: tBox.String(),
});
exports.UserT = tBox.Object({
    ID: tBox.Number(),
    Email: tBox.String(),
    Mobile: (0, meta_types_1.MaybeT)(tBox.String()),
    AuthTier: tBox.Union([tBox.Literal(1), tBox.Literal(2), tBox.Literal(3)]),
    Enabled: meta_types_1.tBoolT,
    Welcomed: meta_types_1.tBoolT,
    Name: tBox.String(),
    Authority: tBox.Number(),
    EmployeeCodes: tBox.Array(tBox.Number()),
    HREmployeeCodes: tBox.Array(tBox.Number()),
    ResidentLinks: tBox.Record(tBox.String(), exports.ResidentLinkT),
});
exports.EmployeeT = tBox.Object({
    EmployeeCode: tBox.Number(),
    Name: tBox.String(),
    Person: (0, meta_types_1.MaybeT)(tBox.Number()),
    Email: (0, meta_types_1.MaybeT)(tBox.String()),
    Surname: tBox.String(),
    FGiven: tBox.String(),
    EndDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    MobileNo: (0, meta_types_1.MaybeT)(tBox.String()),
    Siblings: tBox.Array(tBox.Number()),
    Active: tBox.Boolean(),
});
exports.HREmployeeT = tBox.Object({
    ID: tBox.Number(),
    PayrollDatabase: tBox.Number(),
    PayrollEmpCode: tBox.Number(),
    Email: (0, meta_types_1.MaybeT)(tBox.String()),
    Name: tBox.String(),
    Surname: tBox.String(),
    FGiven: tBox.String(),
    Mobile: (0, meta_types_1.MaybeT)(tBox.String()),
    EndDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
});
exports.ResidentT = tBox.Object({
    PK: tBox.String(),
    ID: tBox.Number(),
    Name: tBox.String(),
    FGiven: tBox.String(),
    Surname: tBox.String(),
    BillingSubFacility: tBox.Number(),
    Contact: tBox.String(),
});
exports.SubRosterT = tBox.Object({
    Roster: tBox.Number(),
    Name: tBox.String(),
});
exports.BillingModelT = tBox.Object({
    SubFacility: tBox.Number(),
    Name: tBox.String(),
});
exports.PayrollModelT = tBox.Object({
    Facility: tBox.Number(),
    Name: tBox.String(),
});
exports.HRModelT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
});
exports.SyncModelT = tBox.Object({
    linkedToOne: (0, meta_types_1.ModelTypeT)(tBox.Number()),
    linkedToMultiple: (0, meta_types_1.ModelTypeT)(tBox.Array(tBox.Number())),
    readyToMerge: (0, meta_types_1.ModelTypeT)(tBox.Number()),
    needsCleanup: tBox.Array(tBox.Number()),
    needsEmail: tBox.Array(tBox.Number()),
    readyToCreate: tBox.Array(tBox.Number()),
    needsEnabling: tBox.Array(tBox.Number()),
    needsDisabling: tBox.Array(tBox.Number()),
});
exports.UserGroupT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    IsGlobal: meta_types_1.tBoolT,
    Users: tBox.Array(tBox.Number()),
});
exports.PermissionRosterT = tBox.Object({
    Subroster: tBox.Number(),
    User: tBox.Number(),
    CanView: tBox.Union([tBox.Literal(0), tBox.Literal(1), tBox.Literal(2)]),
    CanSend: meta_types_1.tBoolT,
    CanAssign: meta_types_1.tBoolT,
    CanEditWorking: meta_types_1.tBoolT,
    CanEditMaster: meta_types_1.tBoolT,
});
exports.PermissionRostersT = (0, meta_types_1.ModelTypeT)(exports.PermissionRosterT);
exports.PermissionBillingT = tBox.Object({
    User: tBox.Number(),
    SubFacility: tBox.Number(),
    CanView: meta_types_1.tBoolT,
    CanEditNotes: meta_types_1.tBoolT,
    CanBudget: meta_types_1.tBoolT,
    CanAgreements: meta_types_1.tBoolT,
    FullAccess: meta_types_1.tBoolT,
});
exports.PermissionPayrollT = tBox.Object({
    UserID: tBox.Number(),
    CanView: meta_types_1.tBoolT,
    Editable: meta_types_1.tBoolT,
});
exports.PermissionHRT = tBox.Object({
    UserID: tBox.Number(),
    CanView: meta_types_1.tBoolT,
    AuthLevel: meta_types_1.tBoolT,
    CanFinaliseContracts: meta_types_1.tBoolT,
    CanApproveOnboarding: meta_types_1.tBoolT,
    IsAppraiser: meta_types_1.tBoolT,
});
var ManagementRoleKinds;
(function (ManagementRoleKinds) {
    ManagementRoleKinds[ManagementRoleKinds["ReceiveLeaveApplications"] = 0] = "ReceiveLeaveApplications";
    ManagementRoleKinds[ManagementRoleKinds["ReceivePayQueries"] = 1] = "ReceivePayQueries";
    ManagementRoleKinds[ManagementRoleKinds["DownloadPortal"] = 2] = "DownloadPortal";
    ManagementRoleKinds[ManagementRoleKinds["ViewRosterCosting"] = 3] = "ViewRosterCosting";
    ManagementRoleKinds[ManagementRoleKinds["HRAppraiser"] = 4] = "HRAppraiser";
})(ManagementRoleKinds || (exports.ManagementRoleKinds = ManagementRoleKinds = {}));
exports.ManagementRoleT = tBox.Object({
    User: tBox.Number(),
    Role: tBox.Enum(ManagementRoleKinds),
});
exports.UsersDataModelT = tBox.Object({
    facility: tBox.Number(),
    subFacilities: tBox.Array(exports.SubFacilityT),
    users: (0, meta_types_1.ModelTypeT)(exports.UserT),
    employees: (0, meta_types_1.ModelTypeT)(exports.EmployeeT),
    hrEmployees: (0, meta_types_1.ModelTypeT)(exports.HREmployeeT),
    subrosters: (0, meta_types_1.ModelTypeT)(exports.SubRosterT),
    billings: (0, meta_types_1.ModelTypeT)(exports.BillingModelT),
    payrolls: (0, meta_types_1.ModelTypeT)(exports.PayrollModelT),
    hrs: (0, meta_types_1.ModelTypeT)(exports.HRModelT),
    syncTodo: exports.SyncModelT,
    userGroups: (0, meta_types_1.ModelTypeT)(exports.UserGroupT),
    permissionRoster: (0, meta_types_1.ModelTypeT)(exports.PermissionRostersT),
    permissionBilling: tBox.Array(exports.PermissionBillingT),
    permissionPayroll: tBox.Array(exports.PermissionPayrollT),
    permissionHR: tBox.Array(exports.PermissionHRT),
    managementRoles: tBox.Array(exports.ManagementRoleT),
    isBureau: tBox.Boolean(),
    residents: tBox.Record(tBox.String(), exports.ResidentT),
});
//# sourceMappingURL=types-users.js.map